export type Language = "en";

export const translations = {
  en: {
    nav: {
      work: "Work",
      writing: "Writing",
      about: "About",
      contact: "Contact",
    },
    hero: {
      role: "Software Engineer",
      subtitle: "I love to try new things in the software world. A 'Swiss Army Knife' engineer who learns by doing and brings AI/ML expertise to every problem.",
      tagline: "Software engineer at Holool, driving digital transformation through hands-on AI integration. I build sovereign AI infrastructure and Darija fine-tuned models — data-first, from vision to speech.",
      currentlyAt: "Currently at",
      viewWork: "View work",
      getInTouch: "Get in touch",
      scroll: "Scroll",
    },
    heroForm: {
      emailPlaceholder: "your@email.com",
      messagePlaceholder: "Your message…",
      next: "Next",
      send: "Send",
      sending: "Sending…",
      sent: "Sent — thanks!",
      invalid: "Enter a valid email",
      error: "Couldn't send. Try again.",
    },
    techStack: {
      title: "Tech Stack",
      subtitle: "Tools I use to grind and build",
    },
    stats: {
      experience: "Years Experience",
      projects: "Projects Delivered",
      technologies: "Technologies Mastered",
      coffee: "Cups of Coffee",
    },
    projects: {
      title: "Work",
      description: "A selection of projects I've built. Each one represents a unique challenge and an opportunity to learn something new.",
      viewGithub: "View on GitHub",
      viewLive: "View live site",
    },
    blog: {
      title: "Writing",
      description: "Thoughts on software development, technology, and building products. Mostly about TypeScript, React, and the modern web.",
      readMore: "Read more",
      minRead: "min read",
      back: "Back to articles",
    },
    about: {
      title: "About",
      bio1: "I'm Mohamed Amine Medjabri, a Software Engineer at Holool. I consider myself a 'Swiss Army Knife' in development - I love trying new things and I never say no to a challenging task.",
      bio2: "This is my first professional role, and I embrace the grind. My philosophy is simple: learn by doing. Whether it's frontend, backend, or DevOps, I dive in headfirst to solve the problem at hand.",
      bio3: "With a Masters degree in AI/ML, I actively try to add intelligence to the ingredients at Holool, bridging the gap between traditional software engineering and modern AI capabilities.",
      downloadResume: "Download Resume",
      skills: "Skills & Technologies",
      experience: "Experience",
    },
    contact: {
      title: "Get in Touch",
      description: "Have a project in mind or just want to say hello? I'd love to hear from you. Fill out the form below or reach out through any of my social channels.",
      sendMessage: "Send a Message",
      contactInfo: "Contact Info",
      followMe: "Follow Me",
      tip: "Tip:",
      tipText: "I typically respond within 24-48 hours. For urgent matters, feel free to reach out via social media.",
      form: {
        name: "Name",
        email: "Email",
        subject: "Subject",
        message: "Message",
        submit: "Send Message",
        sending: "Sending...",
        successTitle: "Message Sent!",
        successText: "Thank you for reaching out. I'll get back to you soon.",
        sendAnother: "Send Another Message",
        error: "Something went wrong. Please try again.",
        namePlaceholder: "Your name",
        emailPlaceholder: "your@email.com",
        subjectPlaceholder: "What's this about?",
        messagePlaceholder: "Your message...",
      },
    },
    footer: {
      tagline: "Software Engineer. Building things with code.",
      rights: "Medjabri Mohamed Amine. All rights reserved.",
    },
  },
};
